import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleMinus,
  faClock,
} from "@fortawesome/pro-regular-svg-icons";
import clsx from "clsx";

import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { equals } from "ramda";

const useStyles = makeStyles(theme => ({
  approved: {
    color: theme.palette.approved,
  },

  pending: {
    color: theme.palette.primary.brandPrimary,
  },

  rejected: {
    color: theme.palette.rejected,
  },
}));

const icons = {
  approved: faCircleCheck,
  pending: faClock,
  rejected: faCircleMinus,
};

const titles = {
  approved: "Approve",
  pending: "Pending",
  rejected: "Reject",
};

const StatusIconButton = ({
  onClick,
  icon = null,
  status,
  tooltipTitle,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <Tooltip title={tooltipTitle || titles[status]}>
      <IconButton
        disabled={disabled}
        className={clsx({
          [classes.approved]: equals(status, "approved"),
          [classes.pending]: equals(status, "pending"),
          [classes.rejected]: equals(status, "rejected"),
        })}
        onClick={onClick}
      >
        {icon || <FontAwesomeIcon icon={icons[status]} />}
      </IconButton>
    </Tooltip>
  );
};

export default StatusIconButton;
